import React, {useEffect, useState} from 'react'
import { Link } from 'react-router-dom';

function Doc() {

 let menu = [
    {'id':1,'title':'Introduction'},
    {'id':2,'title':'Key Features'},
    {'id':3,'title':'Plans'},
    {'id':4,'title':'Onboarding'},
    {'id':5,'title':'Dashboard'},
    {'id':6,'title':'Members'},
    {'id':7,'title':'Givings'},
    {'id':8,'title':'Groups'},
    {'id':9,'title':'HMRC Claims'},
    {'id':10,'title':'Support'},
    {'id':11,'title':'Conclusion'},
  ];
  const [activeMenu, setActiveMenu] = useState('Introduction');
  const switchActive = (id,title) => {
    document.documentElement.style.scrollBehavior = "smooth";
    setActiveMenu(title)
    const element = document.getElementById(title);
    element.scrollIntoView();
  }

  const handleScroll = () => {
    // Logic to identify the active section based on scroll position
    const sectionElements = document.querySelectorAll('.documentation-section');
    
    sectionElements.forEach((section) => {
      const rect = section.getBoundingClientRect();
      if (rect.top <= window.innerHeight * 0.5 && rect.bottom >= window.innerHeight * 0.5) {
        // Section is approximately in the middle of the viewport
        const sectionId = section.getAttribute('id');
        setActiveMenu(sectionId);
        if (sectionId !== activeMenu) {
          setActiveMenu(sectionId);
        }
      }
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  })

  return (
    <div className='grid grid-cols-8 px-5 lg:px-20 lg:pt-10 pb-20 '>
      <div className='col-span-2 hidden lg:block sticky top-0 w-full h-screen overflow-y-auto absolute'>
        <span className='text-[#333333] text-[18px] font-[600]'>CHGAMS DOCUMENTATION</span>
        <div className='flex flex-row mt-8'>
          <div className='w-[1px] bg-[#A5A5A5]'></div>
          <div className='flex flex-col'>
          {menu.map(({id,title}) => {
            return(
              <div className='flex flex-row space-x-5 cursor-pointer' onClick={() => switchActive(id,title)}>
                  <div key={id} className={`w-[1px] ml-[-1px] ${activeMenu == title ? 'bg-[#B30000]' : null}`}></div>
                  <div className={`${activeMenu == title ? 'text-[#B30000]' : 'text-[#A5A5A5]'} text-[14px] ${title != 'Introduction' ? 'pt-4' : null} ${title == 'Conclusion' ? 'pb-10 mb-5' : null}`}>{title}</div>
                </div>
            )
          })}
          </div>
        </div>
      </div>
      <div className='col-span-8 lg:col-span-6 mt-10 flex flex-col space-y-8'>
        <div className='lg:hidden font-[600] text-[20px]'>CHGAMS DOCUMENTATION</div>
          <div className='flex flex-col documentation-section' id="Introduction">
            <div className='text-[#0E0E0E] font-[600] text-[20px]'>Introduction</div>
            <div className='text-[#4F4F4F] text-[16px] mt-3 space-y-2 font-[300]'>
              <p>Thank you for selecting Chgams, the state-of-the-art Software as a Service (SAAS) solution dedicated to elevating the capabilities of charitable organizations and simplifying the journey of making a positive impact. This documentation serves as your comprehensive guide to understanding and optimizing the full potential of Chgams.</p>
              <p>Chgams goes beyond being just software; it's a dynamic force for positive change. We recognize the distinctive challenges faced by charities today and have designed Chgams with a singular mission – to empower organizations like yours with the tools and insights needed to thrive.</p>
              <p>Whether you're a seasoned Chgams user or just embarking on this journey, this documentation is crafted to guide you through every aspect of the platform. From initial setup to advanced features, find comprehensive guides, tutorials, and FAQs to ensure your success.</p>
              <p>Our commitment to your success extends beyond this documentation. Explore our support channels and join our vibrant community to connect with fellow users, share best practices, and stay updated on the latest features and enhancements.</p>
            </div>
          </div>

          <div className='flex flex-col documentation-section' id="New Features">
            <div className='text-[#0E0E0E] font-[600] text-[20px]'>New Features</div>
            <div className='text-[#4F4F4F] text-[16px] mt-3 space-y-2 font-[300]'>
              <ul className='list-disc ml-5 space-y-2'>
                <li>
                  Introducing agent module, where an agent can enrol and process 
                  multiple charities under one single agent account.
                </li>
              </ul>
            </div>
          </div>

          <div className='flex flex-col documentation-section' id="Key Features">
            <div className='text-[#0E0E0E] font-[600] text-[20px]'>Key Features</div>
            <div className='text-[#4F4F4F] text-[16px] mt-3 space-y-2 font-[300]'>
              <ul className='list-disc ml-5 space-y-2'>
                <li>
                  <p className='font-semibold'>User-friendly dashboard</p>
                  <p>Our platform offers an intuitive and easily navigable dashboard designed to provide a smooth and efficient user experience.</p>
                </li>
                <li>
                  <p className='font-semibold'>Member registration and profile management</p>
                  <p>Easily register as a member and manage your profile effortlessly, ensuring a personalized and convenient experience tailored to your needs.</p>
                </li>
                <li>
                  <p className='font-semibold'>Easy donation tracking</p>
                  <p>Seamlessly track and manage donations with simplicity and clarity, allowing you to monitor and organize contributions effortlessly.</p>
                </li>
                <li>
                  <p className='font-semibold'>Group creation and management</p>
                  <p>Create and manage groups efficiently, enabling effective collaboration and streamlined communication among members.</p>
                </li>
                <li>
                  <p className='font-semibold'>Seamless HMRC claims submission</p>
                  <p>Effortlessly submit claims to HMRC (His Majesty's Revenue and Customs) without hassle, ensuring a smooth and efficient process for tax-related submissions..</p>
                </li>
              </ul>
            </div>
          </div>

          <div className='flex flex-col documentation-section' id="Plans">
            <div className='text-[#0E0E0E] font-[600] text-[20px]'>Plans</div>
            <div className='text-[#4F4F4F] text-[16px] mt-3 space-y-2'>
            <ul className='list-disc ml-5 space-y-2 font-[300]'>
                <li className='space-y-1'>
                  <p className='font-semibold'>Starter</p>
                  <p>Starter is a 3-day trial at £0.99. It includes one admin and one member, without HMRC claims.</p>
                </li>
                <li className='space-y-1'>
                  <p className='font-semibold'>Standard</p>
                  <p>Standard is £315.99 per year. It covers up to 210 members, 3 admin users, and HMRC claims up to £10,000 a year.</p>
                </li>
                <li className='space-y-1'>
                  <p className='font-semibold'>Pro</p>
                  <p>Pro is £569.99 per year. It covers up to 500 members, 5 admin users, claims up to £50,000 a year, the member portal, and bulk upload.</p>
                </li>
                <li className='space-y-1'>
                  <p className='font-semibold'>Growth</p>
                  <p>Growth is £799.99 per year. It covers up to 1,000 members, 7 admin users, and claims up to £100,000 a year.</p>
                </li>
                <li className='space-y-1'>
                  <p className='font-semibold'>Custom</p>
                  <p>Custom charges a £947.97 one-time fee for 2, 3, or 4 years, then continues on the £315.99 yearly subscription. It includes Standard limits and claims across multiple years.</p>
                </li>
                <li className='space-y-1'>
                  <p className='font-semibold'>Silver Agency Plans</p>
                  <p>Our Silver agency plans opens you up to the basic features of the CHGAM System, while also allowing you to make claims for multiple charities,
                    with flexibility of you to any of 1-5 Charities, 6-10 Charities, 11-15 Charities. There's the possibility of managing more charities, 
                    that would require contacting our support team @ info@chgams.com
                  </p>
                </li>
                <li className='space-y-1'>
                  <p className='font-semibold'>Gold Agency Plans</p>
                  <p>The Gold agency plans extends the usabilty of the platform by making availabile all possible features for you to work with. We also have a few 
                    categories for which you can contact the support team for possible capacity increase. The plans include; 1-5 Charities, 
                    6-10 Charities, 11-15 Charities.
                  </p>
                </li>
              </ul>
            </div>
          </div>

          <div className='flex flex-col documentation-section' id="Agent">
            <div className='text-[#0E0E0E] font-[600] text-[20px]'>Agent</div>
            <div className='text-[#4F4F4F] text-[16px] mt-3 space-y-2'>
            <ul className='list-disc ml-5 space-y-2 font-[300]'>
                <li className='space-y-1'>
                  <p className='font-semibold'>Introduction</p>
                  <p>The Agency Feature allows individuals or organizations that manage 
                    multiple charities to operate under a single account. With this feature, 
                    an agent can add, view, and manage several charities, make HMRC claims for each, 
                    and perform all other essential functions without needing multiple logins. This 
                    is ideal for users who oversee multiple charities, such as accounting firms, 
                    trustees, or group administrators.
                  </p>
                  <p>This is ideal for users who oversee multiple charities, such as accounting 
                    firms, trustees, or group administrators.
                  </p>
                </li>
                <li className='space-y-1'>
                  <p className='font-semibold'>Key Functions</p>
                  <div className='pl-5'>
                    <li>Add and Manage Charities: Agents can create and link multiple charities to their account.</li>
                    <li>Unified Dashboard: View total donations, members, and HMRC claims across all linked charities.</li>
                    <li>Centralized Claims: Submit and track claims for each charity under one profile.</li>
                    <li>Member and Donation Oversight: Manage records for each charity individually while maintaining separation of data.</li>
                    <li>Unified Dashboard</li>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div className='flex flex-col documentation-section' id="Onboarding">
            <div className='text-[#0E0E0E] font-[600] text-[20px]'>Onboarding</div>
            <div className='text-[#4F4F4F] text-[16px] mt-3 space-y-2'>
            <ul className='list-disc ml-5 space-y-2 font-[300]'>
                <li className='space-y-1'>
                  <p className='font-semibold'>Account Creation</p>
                  <p>The first step in creating your account is selecting if you are registering 
                    as an Agent or Charity. If you are an agent, follow the prompts to 
                    input your Agency information, User Information and choose a plan; 
                    You will then have the priviledge to add more organizations or charities 
                    in your dashboard. If you are simply registering as a Charitable Organization, 
                    provide the details you registered with HMRC. This is so you can directly make 
                    claims from our platform. The details required are your Charity Name, Charity 
                    Reference Number, Charity Registration Number, Charity Registration Body 
                    (England, Ireland, Scottish) most of which can be retrieved from your HMRC 
                    account profile. You will not be able to make a claim if any of the stated 
                    details are not correct.</p>
                </li>
                <li className='space-y-1'>
                  <p className='font-semibold'>Accounting Year</p>
                  <p>The period you define as the start and end of your organization's operations in the year. Input your Accounting Year; this helps us to calculate when you can make claims</p>
                </li>
                <li className='space-y-1'>
                  <p className='font-semibold'>Admin</p>
                  <p>Then we would require the details of whoever is creating the account as Admin details so claims can be easily authorized and the system can be managed</p>
                </li>
                <li className='space-y-1'>
                  <p className='font-semibold'>Plan</p>
                  <p>Last Step in your onboarding is to select your plan (refer to the plans information above)</p>
                </li>
              </ul>
            </div>
          </div>

          <div className='flex flex-col documentation-section' id="Dashboard">
            <div className='text-[#0E0E0E] font-[600] text-[20px]'>Dashboard</div>
            <div className='text-[#4F4F4F] text-[16px] mt-3 space-y-2 font-[300]'>
              The dashboard displays an overview of a charity's performance as relating to donations and members. And you can switch between different accounting years to view different statics.
            <p>To change period or accounting year to view it's statistics, navigate to the 'Givings' page and click on the dropdown that has the different years all the donations you have recorded falls into. Select the period you want and click 'Change period'.</p>
            </div>
          </div>

          <div className='flex flex-col documentation-section' id="Members">
            <div className='text-[#0E0E0E] font-[600] text-[20px]'>Members</div>
            <div className='text-[#4F4F4F] text-[16px] mt-3 space-y-2 font-[300]'>
              Members are regarded as the people associated with an organization particularly those who have been attached over a period of time. Members could be tax payers and non tax papers. Follow the prompts to create a new member for your organization.
            </div>
            <ul className='list-disc ml-5 space-y-2 mt-2 font-[300]'>
                <li className='space-y-1'>
                  <p className='font-semibold'>Gift Aid Declaration</p>
                  <p>Creating members require you stating if claims can be made on their donations (declaring gift aid). However, this is restricted to taxpayers only, in other words, non tax payers cannot declare gift aid but they can still be registered and their donations. Claims can be made on their donations but your charity needed to have made at least 2 claims in the last four years. Refer to the HMRC portal for more information.</p>
                </li>
                <li className='space-y-1'>
                  <p className='font-semibold'>Individual Donations</p>
                  <p>These are donations recorded for tax payers. There are no limitations to this as long as your organization is validated to make claims.</p>
                </li>
                <li className='space-y-1'>
                  <p className='font-semibold'>Members upload (Standard and above)</p>
                  <p>If you already have the details of your members in a CSV or Excel file, you can make an upload. However a few adjusments in accordance to <Link target='_blank' to="/MembersUploadFormat.xlsx" download className='text-[#B30000] font-bold'>this file</Link> might need to be made to your file for a smooth upload.</p>
                  <p><b>Note: Charity Pro can upload up to 500 records per file. Other paid charity plans can upload up to 70. Agency Gold plans can upload up to 100, and Agency Silver plans up to 50.</b></p>
                </li>
              </ul>
          </div>

          <div className='flex flex-col documentation-section' id="Givings">
            <div className='text-[#0E0E0E] font-[600] text-[20px]'>Givings</div>
            <div className='text-[#4F4F4F] text-[16px] mt-3 space-y-2 font-[300]'>
            Givings are the donations received by your organization; you can record donations for members and non members. In line with HMRC, we have 
            created a system where you can record 3 types of donations: Individual, GASDS, Aggregated.
            </div>
            <ul className='list-disc ml-5 space-y-2 mt-2 font-[300]'>
                <li className='space-y-1'>
                  <p className='font-semibold'>Individual Donations</p>
                  <p>These are donations for known members of your charity who have also made gift aid declaration.
                    All fields except ‘comment’ are required when recording donations for members. You are required to fill in the member ID created when the member was created. This can be found on the column details of your members list in your members page. When you input the member ID, you will be prompted to recheck the existence of the member; then you can confirm the member’s name and proceed with the donation record.</p>
                </li>
                <li className='space-y-1'>
                  <p className='font-semibold'>Aggregated donations</p>
                  <p>Combining donations can save a tonne of time when handling very small one-time gifts from visitors 
                    or donors who donate very seldom—gifts that are eligible for Gift Aid. Many Gift Aid envelopes used 
                    during a large event or collection, each containing tiny donations but having their own unique 
                    declarations, is a common scenario that is appropriate for aggregation. A charity can record a 
                    single total for a collection of these tiny gifts, £20 or less, up to £1,000 per line (record) 
                    using the aggregation procedure. This eliminates the need to enter every donor's unique information 
                    for every donation. Please take note that the Gift Aid Small Donations Scheme (GASDS) should not be 
                    confused with aggregated donations. Gift Aid donations that are eligible for aggregation are nevertheless 
                    protected by an audit trail. In the event of an inspection, supporting documents such as envelopes should 
                    be kept on file. When there isn't a Gift Aid audit trail, use GASDS.</p>
                </li>
                <li className='space-y-1'>
                  <p className='font-semibold'>GASDS donations</p>
                  <p>In April 2013, the Gift Aid Small Donations Scheme (GASDS) was launched. HMRC's recent programme, 
                    which lets charities recover a top-up payment on small donations without requiring an audit trail, 
                    was much-needed. Other than maintaining a record of receipts and their origin, no declarations, 
                    names, addresses, or related administration are needed. Donations from frequent donors who do 
                    not pay tax are eligible if they are known to be non-taxable. </p>
                    <p>GASDS is for donations made with cash or contactless cards. Standing orders, checks, and the like are not acceptable. The plan takes into consideration the tax year (1st April - 31st March), which could differ from your accounting year.
                    Donations are requested. A GASDS claim cannot contain any earnings from raffles, events, products you charge for, or anything else that would not have been eligible for Gift Aid. The total amount of donations that can be claimed is limited to £8,000. 
                    Your organisation must also make a standard Gift Aid claim in order to make any GASDS claims at all. To be eligible for the full £8,000 top-up, a charity has to have claimed on Gift Aid payments totaling at least £800.
                    If less, the'matching rule', which determines your GASDS entitlement, applies at a ratio of 1:10. For instance, you would only be eligible for a maximum of £2,000 if you had only claimed £200 in Gift Aid donations.
                    </p>
                </li>
                <li className='space-y-1'>
                  <p className='font-semibold'>Donations upload (Pro, and Gold agency plans)</p>
                  <p>You can also collate your donations in an excel / CSV file and upload for record. Your csv file must have headings (name,id,amount,type,method,date); name is the name of the member, id is the member’s id which will be generated when you create a member, type is the donation type (Offering, Tithe, Others), method is the payment method (Bank Transfer, POS, Cash) and date is the payment date of the donation.
                    For better understand, download a format <Link target='_blank' to="/GivingsDataFormatForUpload.csv" download className='text-[#B30000] font-bold'>here.</Link>
                  </p>
                  <p><strong>Note:</strong></p>
                  <ul className='font-normal list-decimal pl-7'>
                    <li>You can only upload Individual donations and there is a maximum of 500 records per upload. Your payment date must be in the format <span className='font-semibold'>yyyy-mm-dd e.g 2024-10-21</span></li>
                    <li>When you upload giving/donation for a member that does not have gift aid declaration, the donation will be recorded as GASDS.</li>
                  </ul>
                  <p></p>
                </li>
              </ul>
          </div>

          <div className='flex flex-col documentation-section' id="Groups">
            <div className='text-[#0E0E0E] font-[600] text-[20px]'>Groups</div>
            <div className='text-[#4F4F4F] text-[16px] mt-3 space-y-2 font-[300]'>
              You can create groups in your organization and attach members to them. Then, you can manage the groups and donations made by the members in the group.
            </div>
          </div>

          <div className='flex flex-col documentation-section' id="HMRC Claims">
            <div className='text-[#0E0E0E] font-[600] text-[20px]'>HMRC Claims</div>
            <div className='text-[#4F4F4F] text-[16px] mt-3 space-y-2 font-[300]'>
              This is one of the most important modules of our system; it affords the ability to make tax refunds claims on donations made to your organization. This would be much possible on our premium plan. You will be directed by prompts on what to do when you click the “Submit Claim To HMRC” button.
            </div>
            <ul className='list-disc ml-5 space-y-2 mt-2 font-[300]'>
                <li className='space-y-1'>
                  <p className='font-semibold'>Correct Details</p>
                  <p>Ensure your HRMC details are correct before making claims (You can confirm this in your settings)</p>
                </li>
                <li className='space-y-1'>
                  <p className='font-semibold'>Limits</p>
                  <p>Ensure you have at least one member and donation before making a claim.</p>
                </li>
                <li className='space-y-1'>
                  <p className='font-semibold'>Running, History, Draft</p>
                  <p>Claims are categorized into running (donations you can make claims on at the momment), history (Claims you have made), draft (Claims you started making).Your claims will be registered as a draft if it is unable to be processed in the first trial, so you can always retry by going to your claims draft.</p>
                </li>
              </ul>
              <div className='text-[#4F4F4F] text-[16px] mt-3 space-y-2'>
              The claims module also records your past claims and draft for your overview.
              </div>
          </div>

          <div className='flex flex-col documentation-section' id="Support">
            <div className='text-[#0E0E0E] font-[600] text-[20px]'>Support</div>
            <div className='text-[#4F4F4F] text-[16px] mt-3 space-y-2 font-[300]'>
              To clear your concerns or get more support, please find relevant access below.
            </div>
            <ul className='list-disc ml-5 space-y-2 mt-2 font-[300]'>
                <li className='space-y-1'>
                  <p className='font-semibold'>Reach Out</p>
                  <p>Reach out to us to get support <a href='/support' className='text-[#B30000]'>here</a></p>
                </li>
                <li className='space-y-1'>
                  <p className='font-semibold'>FAQs</p>
                  <p>Find commonly asked questions <a href='/#faqs' className='text-[#B30000]'>here</a></p>
                </li>
              </ul>
          </div>

          <div className='flex flex-col documentation-section' id="Conclusion">
            <div className='text-[#0E0E0E] font-[600] text-[20px]'>Conclusion</div>
            <div className='text-[#4F4F4F] text-[16px] mt-3 space-y-2 font-[300]'>
            Thank you for choosing the Charity Management System. We hope this documentation helps you make the most of our platform. Your feedback is valuable for continuous improvement.
            </div>
          </div>

      </div>
    </div>
  )
}

export default Doc